import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpService } from '../../shared/services/http.service';
import { decodeBase64ToText } from '../../utility';
import { ToastService } from '../../shared/services/toast.service';
import _ from 'lodash';
import { HelperService } from '../../shared/services/helper.service';

@Component({
  selector: 'app-wp-form',
  templateUrl: './wp-form.component.html',
  styleUrl: './wp-form.component.css',
})
export class WpFormComponent implements OnInit, OnDestroy{
  env = environment;
  brandListSubs!: Subscription;
  themeListSubs!: Subscription;
  memberListSubs!: Subscription;
  wpListSubs!: Subscription;
  @Output() createFormWP: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateFormWP: EventEmitter<any> = new EventEmitter<any>();
  @Input() updateWpListForm: any;
  @Input() editData: any = {};
  @Input() userData: any;
  @Input() isEditMode: boolean = false;
  @Input() brandLists: any;
  @Input() wpList: any = {};
  @Input() businessThemeLists: any = [];
  @Input() teamMembersLists: any = [];
  @Output() wpFormModal: EventEmitter<any> = new EventEmitter<any>();

  @Input() wpFormModalData: boolean = false; // Detects modal open/close
  @Output() wpFormModalChange = new EventEmitter<boolean>();
  user: any = {};
  therapeuticLists: any = [];
  indicationsLists: any = [];
  uploadedFiles: any[] = [];
  myForm!: FormGroup;
  areaImpactOption = [
    { key: 'cluster', label: 'Cluster' },
    { key: 'affiliate', label: 'Affiliate' },
    { key: 'global', label: 'Global' },
  ];
  selectedBrandId: any;
  members: any = [];
  themeLists: any;
  memberLists: any = [];
  editMembersData: any;
  uploadUrl: string = '';
  tempateData: any
  helper = inject(HelperService);
  isPdfView: boolean=false

  constructor(
    private toastService: ToastService,
    private fb: FormBuilder,
    private httpService: HttpService,
    private cdr: ChangeDetectorRef
  ) {
    this.uploadUrl = `${environment.opbBackendHost}/api/member/workpackage/file/upload`;
   

    this.myForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      theme_id: ['', Validators.required],
      area_of_impact: ['', Validators.required],
      brand: ['', Validators.required],
      indication: ['', Validators.required],
      therapeutic_area: ['', Validators.required],
      document_context: ['', Validators.required],
      document_outcome: ['', Validators.required],
      document_capabilities: ['', Validators.required],
      document_milestones: ['', Validators.required],
      document_resources: ['', Validators.required],
      document_tools: ['', Validators.required],
      document_timeframe: ['', Validators.required],
      document_investments: ['', Validators.required],
      members: [[], Validators.required],
      files: [''],
    });
  }
  selectedMemberNames: any[] = [];
  ngOnChanges(changes: SimpleChanges) {
    if (changes['wpFormModalData'] && !changes['wpFormModalData'].currentValue) {
      this.myForm.reset();
    }
  }
  ngOnInit(): void {
    this.myForm.reset()
    this.cdr.detectChanges();
    if (this.isEditMode) {
      this.patchFormData(this.editData);
    }
  }
  ngOnDestroy() {
    this.brandListSubs?.unsubscribe();
    this.memberListSubs?.unsubscribe();
    this.themeListSubs?.unsubscribe();
    this.wpListSubs?.unsubscribe();
  }

  onMemberSearchChange(event?: any) {
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/member/group/members`,
        {
          search: event?.filter,
        }
      )
      .subscribe(
        (response) => {
          this.teamMembersLists =_.cloneDeep(response?.data)
        },
        (error) => {
          console.error('API Error:', error);
        }
      );
  }

  onMembersChange(event: any): void {
    this.selectedMemberNames = this.myForm.value.members;
  }

  previewPDF(event:any) {
    event.stopPropagation(); 
    this.tempateData = {
      wpName: this.myForm.get('name')?.value || '',
      description: this.myForm.get('description')?.value || '',
      members: this.myForm.get('members')?.value || '',
      background: this.myForm.get('document_context')?.value || '',
      outcome: this.myForm.get('document_outcome')?.value || '',
      capabilities: this.myForm.get('document_capabilities')?.value || '',
      milestones: this.myForm.get('document_milestones')?.value || '',
      resources: this.myForm.get('document_resources')?.value || '',
      tools: this.myForm.get('document_tools')?.value || '',
      timeframe: this.myForm.get('document_timeframe')?.value || '',
      investments: this.myForm.get('document_investments')?.value || ''
    };
    this.tempateData = { ...this.tempateData };
    this.cdr.detectChanges();
  }
  
  removeMember(index: number): void {
    this.selectedMemberNames.splice(index, 1);
    this.myForm.get('members')?.setValue(this.selectedMemberNames)
  }

  onPDFGenerated(): void {
    setTimeout(() => {
      this.tempateData = null;
    }, 100);
  }
  
  removeFile(file_id: any) {
    this.uploadedFiles = this.uploadedFiles.filter(
      (f) => f?.file_id !== file_id
    );
  }

  patchFormData(data: any) {
    this.editMembersData = Array.from(
      new Set(data?.members.map((item: any) => JSON.stringify(item.detail)))
    ).map((detail: any) => JSON.parse(detail));
    this.selectedMemberNames = this.editMembersData;
    this.myForm.patchValue({
      name: data.name,
      description: data.description,
      theme_id: data.theme_id,
      area_of_impact: data.area_of_impact,
      brand: data.brand?.brand_id,
      indication: data?.indication?.indication_id,
      therapeutic_area: data.thearea?.therapeutic_area_id,
      document_context: data.document_context,
      document_outcome: data.document_outcome,
      document_capabilities: data.document_capabilities,
      document_milestones: data.document_milestones,
      document_resources: data.document_resources,
      document_tools: data.document_tools,
      document_timeframe: data.document_timeframe,
      document_investments: data.document_investments,
      files: data?.files || [],
      members: this.selectedMemberNames || [],
    });
    for (let file of data?.files) {
      this.uploadedFiles.push(file);
    }
    this.updateFilesInForm()
    this.selectedBrandId = data.brand?.brand_id;
    this.getTherapeuticList(this.selectedBrandId);
    this.getIndicationsList(data.thearea?.therapeutic_area_id);
  }
  

  onClose() {
    this.myForm.reset()
    this.wpFormModal.emit(false);
  }

  getBrandList() {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/workpackage/brands`, {})
      .subscribe((res: any) => {
        this.brandLists = res?.data;
      });
  }

  onBrandChange(event: any) {
    this.selectedBrandId = event.value;
    this.myForm.get('indication')?.setValue(null)
    this.myForm.get('therapeutic_area')?.setValue(null)
    this.indicationsLists=[]
    if (this.selectedBrandId) {
      this.getTherapeuticList(this.selectedBrandId);
    }
  }

  onTherapeuticAreaChange(event: any) {
    const selectedTherapeuticData = event.value;
    if (selectedTherapeuticData) {
      this.getIndicationsList(selectedTherapeuticData);
    }
  }

  getTherapeuticList(brandId: string) {
    let data = {
      brand_id: brandId,
    };
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/member/workpackage/therapeutic/areas`,
        data
      )
      .subscribe((res: any) => {
        this.therapeuticLists = res?.data;
      });
  }

  getIndicationsList(therapiId: string) {
    let data = {
      brand_id: this.selectedBrandId,
      therapeutic_area_id: therapiId,
    };
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/member/workpackage/indications`,
        data
      )
      .subscribe((res: any) => {
        this.indicationsLists = res?.data;
      });
  }

  onSubmit() {
    if (this.myForm.valid) {
      if (this.isEditMode) {
        let data = {
          ...this.myForm.value,
          package_id: this.editData?.package_id,
        };
        this.httpService
          .post(
            `${environment.opbBackendHost}/api/member/workpackage/update`,
            data
          )
          .subscribe((response: any) => {
            response?.error
              ? this.toastService.error(response?.message)
              : this.toastService.success(response?.message);
              if(!response?.error){
                this.updateFormWP.emit(response.data)
               }
            this.wpFormModal.emit(false);
          });
      } else {
        
        this.httpService
          .post(
            `${environment.opbBackendHost}/api/member/workpackage/create`,
            this.myForm.value
          )
          .subscribe((response: any) => {
            response?.error
              ? this.toastService.error(response?.message)
              : this.toastService.success(response?.message);
            if(!response?.error){
             this.createFormWP.emit(response.data)
            }
            this.selectedMemberNames=[]
            this.uploadedFiles=[]
            this.myForm.reset()
          });
          
         
        this.wpFormModal.emit(false);
      }
    } else {    
      this.markAllControlsAsTouched(this.myForm);
      // const invalidFields = this.getInvalidFields(this.myForm);
      // this.toastService.error(`Invalid fields: ${invalidFields.join(', ')}`);
      // this.toastService.error(`Form is Invalid`);

      return;

    }
  }

  getInvalidFields(form: FormGroup): string[] {
    let invalidFields: string[] = [];
  
    Object.keys(form.controls).forEach((key) => {
      const control = form.get(key);
  
      if (control instanceof FormGroup) {
        invalidFields = invalidFields.concat(this.getInvalidFields(control));
      } else if (control instanceof FormArray) {
        control.controls.forEach((c, index) => {
          if (c.invalid) {
            invalidFields.push(`${key}[${index}]`);
          }
        });
      } else if (control?.invalid) {
        invalidFields.push(key);
      }
    });
  
    return invalidFields;
  }

  
  markAllControlsAsTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.markAllControlsAsTouched(control);
      }
    });
  }

  onUpload(event: any) {
    const decodedData = decodeBase64ToText(event?.originalEvent?.body?.data);
    let response = JSON.parse(decodedData);
    this.uploadedFiles.push(response?.data);
    response?.error
      ? this.toastService.error(response?.message)
      : this.toastService.success(response?.message);
    this.updateFilesInForm();
  }

  updateFilesInForm() {
    this.myForm.patchValue({
      files: this.uploadedFiles.map((file) => file.file_id).join(','),
    });
  }

}
